export const V_TYPE_STRING = 'string';
export const V_TYPE_INTEGER = 'integer';
export const V_TYPE_NUMBER = 'number';
export const V_TYPE_BOOLEAN = 'boolean';
export const V_TYPE_ARRAY = 'array';
export const V_TYPE_OBJECT = 'object';

export const defaultValues = {
  object: '{}',
  number: 0,
  array: '[]',
  string: '',
  boolean: 'false',
  integer: 0,
};

export const variableTypes = [
  {
    text: '-----',
    value: '',
  },
  {
    text: 'String',
    value: V_TYPE_STRING,
  },
  {
    text: 'Integer',
    value: V_TYPE_INTEGER,
  },
  {
    text: 'Number',
    value: V_TYPE_NUMBER,
  },
  {
    text: 'Boolean',
    value: V_TYPE_BOOLEAN,
  },
  {
    text: 'Array',
    value: V_TYPE_ARRAY,
  },
  {
    text: 'Object',
    value: V_TYPE_OBJECT,
  },
];
